const guiColors = {
    'looks-secondary': '#4F8EC2',
    'looks-transparent': 'rgba(79, 142, 194, 0.35)',
    'looks-light-transparent': 'rgba(79, 142, 194, 0.15)',
    'looks-secondary-dark': 'rgba(63, 114, 155, 1)'
};

const blockColors = {};

export {
    guiColors,
    blockColors
};